import { Link } from "gatsby";
import tw, { styled } from "twin.macro";

import headerWaveSrc from "../../../assets/images/header-wave.svg";

export const defaultMenuWidth = 850;
export const resourcesMenuWidth = 870;

export const Menu = styled.div`
  ${tw`flex overflow-hidden whitespace-nowrap`}

  width: ${defaultMenuWidth}px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1) !important;
  border-radius: 20px;

  &:focus {
    outline: none;
  }

  h5 {
    font-size: 16px;
    line-height: 16px;
    margin: 0;
    ${tw`pt-0 pb-2`}
  }

  a {
    ${tw`font-subtitle`}
    color: #626f7f;
  }
`;

const gapWidth = 60;
const gapHeight = 50;

export const MenuLeft = styled.div`
  ${tw`relative flex items-stretch px-6 pt-6 pb-4`}
  gap: ${gapWidth}px;
`;

export const MenuLeftCol = styled.div`
  ${tw`relative`}

  &:not(:last-child) {
    &::after {
      content: "";
      ${tw`absolute top-0 h-full`}
      right: -${gapWidth / 2}px;
      width: 1px;
      background: #eee;
    }
  }
`;

export const MenuLeftColContent = styled.div`
  ${tw`flex gap-8`};
`;

export const MenuRight = styled.div`
  ${tw`relative flex flex-col pl-10 pr-8 pt-6 pb-4 flex-grow`}

  background: linear-gradient(90deg, #f1f4f7 3.32%, #f1f4f7 198.67%);

  &::after {
    content: "";
    position: absolute;
    background-image: url(${headerWaveSrc});
    width: 1px;
    height: 100%;
    right: -30px;
    top: 0px;
  }

  &::after {
    content: "";
    ${tw`absolute h-full left-0 top-0`}
    background-image: url(${headerWaveSrc});
    width: 20px;
  }
`;

export const MenuLeftProduct = styled.div`
  ${tw`relative flex flex-col items-stretch px-6 pt-6 pb-3 w-full`}
  gap: ${gapHeight}px;
`;

export const MenuLeftRow = styled.div`
  ${tw`relative`}

  &:not(:last-child) {
    &::after {
      content: "";
      ${tw`absolute left-0 w-full`}
      bottom: -${gapHeight / 2}px;
      height: 1px;
      background: #eee;
    }
  }
`;

export const MenuItem = styled((props) => <Link {...props} />)`
  font-size: 16px;
  ${tw`flex px-0! py-2! m-0! cursor-pointer`}
  text-transform: none;
  font-weight: normal;

  &:hover {
    color: #232e3b;
    text-decoration: none;
  }

  &.solution-retain {
    ${tw`font-title font-semibold text-retain`}
  }

  &.solution-convert {
    ${tw`font-title font-semibold text-convert`}
  }

  &.solution-customer-portal {
    ${tw`font-title font-semibold text-customer-portal`}
  }
`;

export const MenuItemAnchor = styled.a`
  font-size: 16px;
  ${tw`flex px-0! py-2! m-0! cursor-pointer text-theme-gray-7`}
  text-transform: none !important;
  font-weight: normal !important;

  &:hover {
    color: #232e3b !important;
    text-decoration: none !important;
  }
`;

export const BlueMenuItem = styled(MenuItem)`
  ${tw`!font-title !text-theme-blue-1 !font-semibold`}

  &:hover {
    color: #004ce2 !important;
    text-decoration: underline !important;
  }
`;

export const Integrations = tw.div`flex flex-wrap -mx-4`;

export const Integration = styled((props) => <Link {...props} />)`
  ${tw`block flex items-center mx-4 my-2`}
  width: 100px;
  display: flex !important;
  text-transform: none !important;
  font-weight: normal !important;
  cursor: pointer;
  &:hover {
    color: #2f74ff !important;
    text-decoration: none !important;
    div {
      opacity: 0.85;
    }
  }
`;

export const MobileIntegration = styled((props) => <Link {...props} />)`
  ${tw`block flex !items-center m-0 !p-0 font-subtitle`}
  width: 100px;
  font-size: 14px !important;
  display: flex !important;
  text-transform: none !important;
  font-weight: normal !important;
  cursor: pointer;

  &:hover {
    color: #2f74ff !important;
    text-decoration: none !important;
    div {
      opacity: 0.85;
    }
  }
`;

export const IntegrationIcon = styled.div<{ color: string }>`
  ${tw`flex items-center justify-center mr-2`}
  min-width: 32px;
  height: 32px;
  border-radius: 0.25rem;
  background-color: ${(props) => props.color};

  img {
    max-width: 32px;
  }
`;
